export default __webpack_public_path__ + "static/media/G0002.d16800f8.png";